import { Component } from '@angular/core';

@Component({
  selector: 'app-preview-layout',
  templateUrl: './preview-layout.component.html'
})
export class PreviewLayoutComponent {
}
